(function () {
	'use strict';
	angular.module('SMART2').directive('smartDropdown', ['$window', '$timeout', '$rootScope', function ($window, $timeout, $rootScope) {
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			scope: {
				config: "@",
				show: "@",
				onHide: "&",
				stopProg: "@",
				triggerOpenEvent: '@'
			},
			link: function (scope, element, attrs) {
			    var keycodeis,
			     hideOnTabOut = function (e) {
			         if (e.keyCode == 9) {
			             keycodeis = e.keyCode;
			             window.lastOpenedDropdownConfig.activates.hide().removeClass('active');
			             window.lastOpenedDropdownConfig.origin.removeClass("active");
			             window.lastOpenedDropdownConfig.activates.unbind("keydown", hideOnTabOut);
			         };
			     };
				//initialization
				setTimeout(function () {
					var element = angular.element(".dropdown-button");
					$(element).dropdown(angular.extend(typeof scope.$eval(attrs.config) == "object" ? scope.$eval(attrs.config) : {}, {
						onHide: scope.onHide
					}));
					if (angular.element(".dd-close-off").length > 0) {
						angular.element(".dd-close-off").click(function (e) {
                           var _elem = angular.element(e.target);	
                           if(!_elem.hasClass("btn-flat") && !_elem.hasClass("btn") && !_elem.hasClass("btn-large")){
								e.stopPropagation();
							}
                        });
                    }
                        });

				if (scope.$eval(attrs.fixed)) {
					$(element).find('.dropdown-content').addClass('fixeddd');
					$(element).find('.dropdown-button').bind('click', function (e) {
						(function ($t) {
							setTimeout(function () {
								var ddCnt = $t.next('.dropdown-content');
								ddCnt.css({ 'left': e.clientX - e.offsetX - 2 + 'px', 'top': e.clientY - e.offsetY - 2 + 'px' });
								//ddCnt.attr('style', function (i, s) { return s + 'display: block !important;' });
								var lastScrollPosition = e.clientY - e.offsetY - 2,
									newScrollPosition = e.clientY - e.offsetY - 2;

								var ddHgt = ddCnt.css('height'),
                                    winHgt = angular.element(window).height();
								if ((parseInt(ddHgt) + e.clientY) > winHgt) {
									var diffHgt = (parseInt(ddHgt) + e.clientY) - winHgt;
									ddCnt.css('top', (e.clientY - e.offsetY - diffHgt - 15) + 'px');
									lastScrollPosition = (e.clientY - e.offsetY - diffHgt - 15),
									newScrollPosition = (e.clientY - e.offsetY - diffHgt - 15);
								}

								angular.element($window).on("scroll.smartFixedSmartDrop", function () {
									newScrollPosition = this.pageYOffset;
									if (newScrollPosition !== lastScrollPosition) {
										if (ddCnt.hasClass('active')) {
											scope.hideDropDown(ddCnt);
										}
									}
									lastScrollPosition = newScrollPosition;
								});
								if (attrs.singleElementDropdown != undefined) {
								    ddCnt.bind("keydown", hideOnTabOut);
								};
							});
						})($(this));
					});

				} else {

				    // Animation from bottom to top
				    $(element).find('.dropdown-button').bind('click', function (e) {
				        var dropdownContent = $(this).next('.dropdown-content');
				        if (attrs.singleElementDropdown != undefined) {
				            dropdownContent.bind("keydown", hideOnTabOut);
				        };
				        $(this).next('.dropdown-content').addClass('ddautoHeight');
				        (function ($t) {
				            setTimeout(function () {
				                var ddCnt = $t.next('.dropdown-content');
				                var ddCntTop = (parseInt(ddCnt.css('top')) + 5) + 'px';
				                var ddCntLeft = (parseInt(ddCnt.css('left')) + 5) + 'px';
				                if (parseInt(ddCntTop, 10) < 0) {
				                    ddCnt.css('top', 0);
				                    ddCnt.animate({
				                        top: ddCntTop, left: ddCntLeft
				                    });
				                }
						    if(scope.triggerOpenEvent === "true"){
						    	 $rootScope.$broadcast("dropdownOpenEvent");
						    }
				            });
				        })($(this));
				    });
				}


				var onShow = attrs.$observe('show', function (value) {
					if (angular.isDefined(value)) {
						if (!scope.$eval(value)) {
							var dropdown = element.find('.dropdown-content');
							scope.hideDropDown(dropdown);
						}
					}
				});


				scope.hideDropDown = function (dropdown) {
					if (dropdown.length > 0) {
						dropdown.fadeOut(250);
						dropdown.removeClass('active');
						dropdown.css('max-height', '');
						angular.element("[data-activates='" + dropdown.attr('id') + "']").removeClass('active');
						angular.isFunction(scope.onHide) && scope.onHide();
					}
				}

                /*Stop Propogation: Start*/
				if (scope.stopProg === "true") {
				    $timeout(function () {
				        element.find(".dropdown-button").click(function (e) {
				            e.stopPropagation();
				        }).end().find(".dropdown-content").click(function (e) {
                            //Close dropdown after option get selected
				            var a = window.lastOpenedDropdownConfig;
				            a.activates.fadeOut(a.options.outDuration);
				            a.activates.removeClass('active');
				            a.activates.css('max-height', '');
				            a.origin.removeClass('active');
				            e.stopPropagation();
				        });
				    })
				}
			    /*Stop Propogation: End*/

				scope.$on('$destroy', function () {
					onShow();
					angular.element($window).off("scroll.smartFixedSmartDrop");
				});
			},
			templateUrl: 'shared/directives/uiElements/smartDropdown/smartDropdownTemplate.html'
		};
	}]);


    angular.module('SMART2').directive('actionCloseDropdown', [function () {
        return {
            restrict: 'C',
            scope: true,
            link: function (scope, element, attrs) {
                //[commenting the traverseAndFireHideDropDown function as it takes time to close/hide dropdown container as soon as closing event is fired]
                //var traverseAndFireHideDropDown = function (scopeRef, dropdown) {
                //    for (var key in scopeRef) {
                //        if (key == 'hideDropDown') {
                //            scopeRef.hideDropDown(dropdown);
                //            return;
                //        }
                //    }
                //    traverseAndFireHideDropDown(scopeRef.$parent, dropdown);
                //    dropdown = null; //[OPTIMIZATION]
                //};

                element.bind('click', function () {
                    var dropdown = element.closest('.dropdown-content');
                    dropdown.hide();
                    //traverseAndFireHideDropDown(scope.$parent, element.closest('.dropdown-content')); // [OPTIMIZATION]
                });

                scope.$on('$destroy', function () {
                    element.unbind('click');
                });
            }
        };
    }]);
})();
